<script>
import { mapState } from 'vuex'
import date from 'locutus/php/datetime/date'
import defaults from 'lodash/defaults'
import { fetchAccount, createAccount, updateAccount } from '@apis/admin/account'
import { fetchAssets } from '@apis/admin/asset'
import fromPairs from 'lodash/fromPairs'

export default {
  props: {
    account_seq: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      assets: [],
      params: {},
      loading: false,
    }
  },
  computed: {
    ...mapState('common', {
      constants: (state) => state.constants,
    }),
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.loading = true
      Promise.all([this.loadAccount(), this.loadAssets()])
        .catch((e) => this.$toasted.error(e.message))
        .finally(() => {
          this.loading = false
        })
    },
    async loadAssets() {
      if (this.account_seq) return []

      const { data } = await fetchAssets()

      this.assets = data
    },
    async loadAccount() {
      const { account_info } = await fetchAccount(
        this.params.seq || this.account_seq
      )
      this.params = defaults(account_info, {
        seq: null,
        balance: null,
        holding_balance: null,
        status: null,
        title: '',
        member_seq: this.$route.params.member_seq,
        asset_seq: null,
      })
    },
    handleSubmit() {
      const createOrUpdate = this.params.seq ? updateAccount : createAccount
      const confirm_message = this.params.seq
        ? this.$t('admin.msg_save')
        : this.$t('admin.msg_account')
      const success_message = this.params.seq
        ? this.$t('admin.msg_account_modify')
        : this.$t('admin.msg_account_open')

      this.loading = true
      this.$confirm(confirm_message, this.$t('admin.modal_confirm'))
        .then(() => createOrUpdate(this.params))
        .then(({ seq }) => this.$emit('submit', seq))
        .then(() => this.$toasted.success(success_message))
        .catch((e) => (e ? this.$toasted.error(e.message) : null))
        .finally(() => {
          this.loading = false
        })
    },
    date,
    fromPairs,
  },
}
</script>

<template>
  <form
    v-loading="loading"
    action="./"
    method="get"
    @submit.prevent="handleSubmit"
  >
    <table cellspacing="0" cellpadding="0" :class="$style.rowTable">
      <colgroup>
        <col width="20%" />
        <col width="30%" />
        <col width="20%" />
        <col width="30%" />
      </colgroup>
      <tbody>
        <tr>
          <th scope="row"
            ><div>{{ $t('wallet.account_seq') }}</div></th
          >
          <td>{{ params.seq || $t('admin.auto') }}</td>
          <th scope="row"
            ><div>{{ $t('wallet.account_number') }}</div></th
          >
          <td>{{ params.seq ? params.account_number : $t('admin.auto') }}</td>
        </tr>
        <tr>
          <th scope="row"
            ><div>{{ $t('wallet.account_name') }}</div></th
          >
          <td
            ><input
              v-model="params.title"
              type="text"
              :class="[$style.inputTypeText, $style.fullWidth]"
          /></td>
          <th scope="row"
            ><div>{{ $t('wallet.regdate') }}</div></th
          >
          <td>{{
            params.seq
              ? date('Y-m-d H:i:s', new Date(params.regdate))
              : $t('wallet.before_regdate')
          }}</td>
        </tr>
        <tr>
          <th scope="row"
            ><div>{{ $t('admin.target_asset_title') }}</div></th
          >
          <td>
            <ElSelect
              v-if="!params.seq"
              v-model="params.asset_seq"
              filterable
              placeholder="Select"
            >
              <ElOption
                v-for="asset in assets"
                :key="asset.seq"
                :label="`${asset.title} (${asset.code})`"
                :value="asset.seq"
              >
              </ElOption>
            </ElSelect>
            <template v-else>{{ params.asset_title }}</template>
          </td>
          <th scope="row"
            ><div>{{ $t('admin.status') }}</div></th
          >
          <td>{{ fromPairs(constants.account.status)[params.status] }}</td>
        </tr>
        <tr>
          <th scope="row"
            ><div>{{ $t('wallet.balance') }}</div></th
          >
          <td>{{ params.balance }}</td>
          <th scope="row"
            ><div>{{ $t('wallet.hold_balance') }}</div></th
          >
          <td>{{ params.holding_balance }}</td>
        </tr>
        <tr>
          <th colspan="4" :class="$style.button">
            <span :class="[$style.button, $style.black]"
              ><input
                type="submit"
                :value="params.seq ? $t('admin.save') : $t('admin.enroll')"
            /></span>
          </th>
        </tr>
      </tbody>
    </table>
  </form>
</template>

<style lang="scss" module>
@import '@src/design/default.scss';
@import '@src/design/admin.scss';
@import '@src/design/font.scss';
@import '@src/design/button.scss';
</style>
